import React from 'react';

import Link from 'ui/Link';
import { Text } from 'ui/Typography';

import { websiteLinkTo } from '../../utils/routes';
import { useCurrentUser } from '../../utils/user';

const NoOrganizationDiagramsCTA: React.FC = () => {
  const { user } = useCurrentUser();

  // Show CTA to add more seats if user has business subscription
  if (user?.default_team?.has_business_subscription) {
    return (
      <Text color="gray.500" fontSize="sm">
        No other members of your organization have shared any diagrams yet.{' '}
        <Link href={websiteLinkTo('/teams/manage')} isExternal>
          Invite more members
        </Link>
      </Text>
    );
  }

  // Otherwise ask user to subscribe / upgrade to the Business plan
  // TODO: Mention "exclusive corporate branding" when released
  return (
    <Text color="gray.500" fontSize="sm">
      Ready to collaborate with your team?{' '}
      {user?.has_active_subscription ? 'Upgrade' : 'Subscribe'} to{' '}
      <Link href={websiteLinkTo('/subscriptions')} isExternal>
        Business subscription
      </Link>{' '}
      and unlock unlimited diagrams with exclusive corporate branding for your
      organization!
    </Text>
  );
};

export default NoOrganizationDiagramsCTA;
